<div class="col-md-12">
  <div class="row-no-margin">
    <span class="popup-header">Item Summary</span>
  </div>
  <div class="row-no-margin" *ngIf="Item.SelectionSummary != null && Item.SelectionSummary.length > 0">
    <span>
      Configuration String:{{Item.Item}}
    </span>
  </div>
  <div class="row-no-margin" *ngIf="Item.SelectionSummary == null || Item.SelectionSummary.length == 0">
    <span class="itemsummary-header">
      {{Item.Item}}
    </span>
  </div>
  <div class="row-no-margin">
    <span>{{Item.Description}}</span>
  </div>
  <div class="row-no-margin" *ngIf="Item.OrderConfigurable == false && Item.Description2 != null && Item.Description2.length > 0">
    <span>{{Item.Description2}}</span>
  </div>

  <div *ngIf="SummaryItems != null && SummaryItems.length > 0" class="row-no-margin" style="margin-top:10px;">
    <span class="itemsummary-header">
      Product Specs
    </span>
    <br />
    <div class="col-md-12" style="border-top:1px solid #333333;">
      <div *ngFor="let sumItem of SummaryItems" class="itemsummary-tile">
        <span class="itemsummary-header">{{sumItem.Header}}</span>
        <br />
        <span class="itemsummary-desc">{{sumItem.Description}}</span>
      </div>
    </div>
  </div>
</div>
